import React, { useState, useEffect } from "react";
import "../../css/style-new.css";
import "../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../css/font.css";
import Logo from "../../images/logo.jpg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { loginurl, GOOGLECLIENTID } from '../../apis/urls';
import { relativeTimeRounding } from "moment";
import { $ } from "react-jquery-plugin";
import { Notification, Placeholder } from "rsuite";
import GoogleLoginButton from "../../common-components/GoogleLoginButton";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";


const Login = () => {



  const [uname, setUname] = useState('');
  const [pword, setPword] = useState('');
  const [unameerror, setUnameerror] = useState('');
  const [pworderror, setPworderror] = useState('');
  const [incorrect, setIncorrect] = useState('');
  const [login, setLogin] = useState(false);
  const [adminPassowrd, setAdminPassword] = useState(true);


  let navigate = useNavigate();

  useEffect(() => {

    $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');


    let storevariable = localStorage.getItem('token');
    let username = localStorage.getItem('username');
    let userid = localStorage.getItem('userid');
    let userrole = localStorage.getItem('userrole');
    let schools = localStorage.getItem('schoolid')
    let associations = localStorage.getItem('association')
    let official = localStorage.getItem('official');
    let coachid = localStorage.getItem('coachid');
    console.log('stvar', storevariable)
    //if( storevariable != 'undefined' || storevariable != null )
    if (storevariable) {

      storeCollector(storevariable, username, userid, userrole, schools, associations, official, coachid);
      //localStorage.clear();
    }


  }, []

  );


  const storeCollector = (a_token, username, uid, urole, school, association, officials, coachid) => {
    localStorage.setItem('token', a_token)
    localStorage.setItem('username', username)
    localStorage.setItem('userid', uid)
    localStorage.setItem('userrole', urole)
    localStorage.setItem('schoolid', school)
    localStorage.setItem('association', association)
    localStorage.setItem('official', officials)
    localStorage.setItem('coachid', coachid)

    let store = localStorage.getItem('token');
    let role = localStorage.getItem('userrole');
    let usid = localStorage.getItem('userid');
    let schoolid = localStorage.getItem('schoolid')
    let associationid = localStorage.getItem('association');
    let official_id = localStorage.getItem('official')
    let coachId = localStorage.getItem('coachid')
    //let ustore = localStorage.getItem('username');
    console.log('auth_token', official_id)
    if (store != 'undefined' || store != null) {


      if (role === 'HO_SCHOOL') {
        let path = '/school_profile/' + schoolid;
        navigate(path)
        //window.location.reload()

      } else if (role === 'ATHLETIC_MANAGER') {

        //console.log('schoolid',schoolid)
        let path = '/school_profile/' + schoolid;
        navigate(path)
        //window.location.reload()


      } else if (role === 'ASSOCIATION_USER') {
        // let path = '/associationview/'+ associationid;        
        // navigate(path)
        //window.location.reload()
        // alert("Go to Association Login Page")


        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')


      } 
      
      else {

        // alert("Go to Admin Login Page")

        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')


        // let path = '/dashboard';        
        // navigate(path)
        //window.location.reload()
      }
    }

  }


  const onFormSubmit = (e) => {
    e.preventDefault()
    let error = 0;

    if (uname === '' && pword === '') {
      setUnameerror('Enter the username')

      setPworderror('Enter the Password')

      error = 1;
    } else if (uname !== '' && pword === '') {
      setUnameerror('')

      setPworderror('Enter the Password')
      error = 1;

    } else if (uname === '' && pword !== '') {
      setUnameerror('Enter the username')

      setPworderror('')
      error = 1;

    }
    else if (uname === '') {
      setUnameerror('Enter the username')
      error = 1;
    } else if (pword === '') {
      setPworderror('Enter the password')
      error = 1;
    }
    else {
      setUnameerror('')

      setPworderror('')
    }


    if (error === 0) {

      loginFunction(uname, pword, false, null);
      // const instance = axios.create({

      //   baseURL: loginurl,

      //   timeout: 1000000,

      // });

      // const data = {
      //   username: uname,
      //   password: pword
      // }

      // instance.post('', data).then((response) => {

      //   if(response.data.data.role === 'SUPERADMIN' || response.data.data.role === 'ASSOCIATION_USER'){
      //     setAdminPassword('Invalid username or password')
      //   }else{
      //     console.log('coachdata', response.data.data)
      //     storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid);
  
      //   }
      // }).catch((error) => {
      //   //console.log('error',error.response.data.message)
      //   setIncorrect(error.response.data.message)

      // });




    }

  }

  const handleLoginSuccess = (response) => {
    console.log('Login Success:', response);

    const decodedToken = jwtDecode(response.credential);
    const email = decodedToken.email;
    loginFunction(email, pword, true, response.credential);
    console.log('decodedToken', email)
  };

  const handleLoginFailure = (response) => {
    console.log('Login Failed:', response);
    // Handle login failure
  };

  const loginFunction = async (uname, pword, googlelogin, authToken) => {

    const instance = axios.create({

      baseURL: loginurl,

      timeout: 1000000,

    });

    const data = {
      username: uname,
      password: pword,
      authToken: authToken,
      googlelogin: googlelogin,
    }

    instance.post('', data).then((response) => {

      if(response.data.data.role === 'SUPERADMIN' || response.data.data.role === 'ASSOCIATION_USER'){
        setAdminPassword('Invalid username or password')
      }else{
        console.log('coachdata', response.data.data)
        storeCollector(response.data.data.accessToken, response.data.data.username, response.data.data.id, response.data.data.role, response.data.data.school, response.data.data.association, response.data.data.officials, response.data.data.coachid);

      }
    }).catch((error) => {
      //console.log('error',error.response.data.message)
      setIncorrect(error.response.data.message)

    });
  }




  return (

    <div className="wrapper loginp">
      <aside className="left-side login-leftside side-off-canvas">
        <div className="logo-wrpr">
          <img src={Logo} width="" height="" alt="" />
        </div>


      </aside>

      <aside className="right-side login-rightside">




      <div className="content-area no-header">

      <div class="google-login-box">
					<h3 style={{color:'white'}}>Already have an account? Please Login</h3>
					<span style={{display:'flex'}} class="google-badge-cntnr">
          
            <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
                <div >
                  <GoogleLoginButton 
                    onSuccess={handleLoginSuccess}
                    onFailure={handleLoginFailure}
                  />
                </div>
              </GoogleOAuthProvider>
               <span style={{marginLeft:'8px', marginTop:'6px'}}>or</span>
          </span>
				</div>

          <form onSubmit={(e) => { onFormSubmit(e) }} className="needs-validation" noValidate>
            <div className="login-title text-center text-white">Login</div>
            <div className="form-group">
              <label htmlFor="uname">Username:</label>
              <input type="text" className="form-control" value={uname} onChange={e => setUname(e.target.value)} id="uname" placeholder="Enter username" name="uname" required></input>
              <div className="valid-feedback">Valid.</div>
              <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{unameerror}</div>
            </div>
            <div className="form-group">
              <label htmlFor="pwd">Password:</label>
              <input type="password" className="form-control" value={pword} onChange={e => setPword(e.target.value)} id="pwd" placeholder="Enter password" name="pswd" required></input>
              <div className="valid-feedback">Valid.</div>
              <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{pworderror}</div>
              <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{incorrect}</div>
              <div className="errors" style={{ color: "white", fontSize: "12.8px" }}>{adminPassowrd}</div>

              
            </div>

            <div className="forgot-pass-and-login-btn ">
              <Link to="/forgot_password" className="forgot">Forgot Password?</Link>

              <button type="submit" className="btn btn-primary">Login <i className="icon-keyboard_arrow_right"></i></button>
            </div>

          </form>

        </div>

      </aside>

    </div>
  );



};

export default Login;